import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuPortal,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
} from '@radix-ui/react-dropdown-menu';
import { Button } from '@ui/components/atoms/button';
import { ChevronDown, Pencil, Reply, Copy as CopyIcon } from 'lucide-react';

interface IProps {
  onEdit?: () => void;
  onReply?: () => void;
  onCopy?: () => void;
}
export function MessageItemDropdown({ onEdit, onReply, onCopy }: IProps) {
  // Don't render if no actions are available
  if (!onEdit && !onReply && !onCopy) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="icon-primary" className="ml-auto mt-1 mr-1 outline-none focus:outline-none">
          <ChevronDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuPortal>
        <DropdownMenuContent
          className="w-32 bg-white p-2 rounded shadow-lg border z-[9999]"
          align="end"
          sideOffset={5}>
          <DropdownMenuGroup className="space-y-1">
            {onEdit && (
              <DropdownMenuItem
                className="text-sm flex flex-row items-center focus:outline-none cursor-pointer hover:bg-gray-100 transition-colors duration-150 px-2 py-1.5 rounded"
                onClick={onEdit}>
                <Pencil className="h-4 w-4 mr-2" />
                Edit
              </DropdownMenuItem>
            )}
            {onReply && (
              <DropdownMenuItem
                className="text-sm flex flex-row items-center focus:outline-none cursor-pointer hover:bg-gray-100 transition-colors duration-150 px-2 py-1.5 rounded"
                onClick={onReply}>
                <Reply className="h-4 w-4 mr-2" />
                Reply
              </DropdownMenuItem>
            )}
            {/* {onCopy && (
              <DropdownMenuItem
                className="text-sm flex flex-row items-center focus:outline-none cursor-pointer hover:bg-gray-100 transition-colors duration-150 px-2 py-1.5 rounded"
                onClick={onCopy}>
                <CopyIcon className="h-4 w-4 mr-2" />
                Copy
              </DropdownMenuItem>
            )} */}
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  );
}
